import { SimulationActionTypes, UpdateFixedPricesPayload } from './types'

export const UPDATE_FIXED_PRICES = 'SIMULATION/UPDATE_FIXED_PRICES'

export const updateFixedPrices = ({ electricity, gas }: UpdateFixedPricesPayload): SimulationActionTypes => {
  return { type: UPDATE_FIXED_PRICES, electricity, gas }
}
